import { Dropdown } from 'primereact/dropdown'
import { classNames } from "primereact/utils"
import InputFrame from "./InputFrame"
import { useRef, useState } from 'react'

export default function InputDropdownForm(props) {

    const field = props.controller.field
    const fieldState = props.controller.fieldState
    const opened = useRef(false)
    const [iconRefresh, setIconRefresh] = useState('pi-refresh')

    const onLoad = (e) => {

        if (opened.current) {
            return
        }

        opened.current = true
        props.onLoad && props.onLoad(e)

    }

    return (
        <>
            <InputFrame {...props}>
                {opened.current && !props.disabled && !props.hideRefresh && <i className={`pi ${iconRefresh} text-xs ml-2`} onClick={e => {

                    if (!iconRefresh.includes('spin') && !iconRefresh.includes('check')) {

                        setIconRefresh('pi-spin pi-refresh')
                        e.preventDefault()
                        props.onLoad && props.onLoad({})
                        setIconRefresh('pi-check')
                        setTimeout(_ => setIconRefresh('pi-refresh'), 5000)
                    }
                }} ></i>}
                <Dropdown
                    {...field}
                    id={'box-' + field.name}
                    inputId={field.name}
                    locale="pt"
                    autoComplete="off"
                    className={'p-inputtext-sm ' + (fieldState.isDirty ? '' : '') + classNames({ 'p-invalid': fieldState.error })}
                    size='small'
                    options={props.options || []}
                    onClick={(e) => {
                        props.onClick && props.onClick(e)
                        onLoad(e)
                    }}
                    onShow={(e) => {
                        props.onShow && props.onShow(e)
                        onLoad(e)
                    }}
                    optionLabel={props.optionLabel || ''}
                    placeholder={props.placeholder || ''}
                    emptyMessage={props.emptyMessage || 'Selecionar'}
                    disabled={props.disabled}
                    showClear={false}
                    autoOptionFocus={true}

                />
            </InputFrame>
        </>
    )
}